module.exports = __webpack_public_path__ + "img/circle-2.24b55324.png";